import { Helmet } from "react-helmet-async";
import { DOMAIN } from "../i18n";

export function Seo({ title, description, enPath, frPath, lang, jsonLd, noindex = false }) {
  const canonical = DOMAIN + (lang === "fr" ? frPath : enPath);
  const schemas = jsonLd ? [].concat(jsonLd) : [];
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en-CA" href={DOMAIN + enPath} />
      <link rel="alternate" hrefLang="fr-CA" href={DOMAIN + frPath} />
      <link rel="alternate" hrefLang="x-default" href={DOMAIN + enPath} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === "fr" ? "fr_CA" : "en_CA"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="1st Nations Security" />
      <meta property="og:image" content={`${DOMAIN}/og-image.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${DOMAIN}/og-image.png`} />
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}

export const faqJsonLd = (faq) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.map(([q, a]) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a }
  }))
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({
    "@type": "ListItem",
    position: i + 1,
    name,
    item: DOMAIN + path
  }))
});

export const serviceJsonLd = (name, description, path, areaName) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: DOMAIN + path,
  provider: {
    "@type": "LocalBusiness",
    name: "1st Nations Security",
    telephone: "+1-807-770-0243",
    email: "admin@1stnation-security.com",
    url: DOMAIN + "/"
  },
  areaServed: { "@type": "Place", name: areaName }
});
